import { render, staticRenderFns } from "./EntryEditDialog.vue?vue&type=template&id=2ba27b0d&"
import script from "./EntryEditDialog.vue?vue&type=script&lang=ts&"
export * from "./EntryEditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports